// ── Backend V2 API ──────────────────────────────────────────
const BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";

function getToken() {
  return localStorage.getItem("accessToken") || "";
}

function authHeaders() {
  const token = getToken();
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

// ── Public ──────────────────────────────────────────────────

export async function fetchServices() {
  const response = await fetch(`${BASE}/api/services`);
  if (!response.ok) throw new Error("Failed to fetch services");
  const data = await response.json();
  return data.services;
}

// ── Admin (protected) ───────────────────────────────────────

export async function insertService(newService) {
  const response = await fetch(`${BASE}/api/services`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(newService),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || "Failed to insert service");
  }
  return response.json();
}

export async function updateService(id, updatedService) {
  const response = await fetch(`${BASE}/api/services/${id}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(updatedService),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || "Failed to update service");
  }
  return response.json();
}

export async function deleteService(id) {
  const response = await fetch(`${BASE}/api/services/${id}`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error("Failed to delete service");
}
